/**
 * Copyright (C) 2019 Egylis,
 * Siège social, 83 bis rue de l'Abbé Groult, 75015 Paris - France.
 * All Rights Reserved.
 *
 * E-mail : info@egylis.com
 *
 * This software is the confidential and proprietary information
 * of Egylis. ("Confidential Information"). You shall not
 * disclose such Confidential Information and shall use it only
 * in accordance with the terms of the license agreement you
 * entered into with Egylis.
 *
 * Created by calvez on 20/03/19.
 *
 * Version : Generator 2.0.9
 */

/// <reference types="cordova-plugin-dialogs" />

import {Injectable, NgZone} from '@angular/core';
import {BehaviorSubject, fromEvent, Observable} from 'rxjs';
import {ToastrService} from 'ngx-toastr';
import {LogService} from '../log/logService';

function _window(): any {
    // return the global native browser window object
    return window;
}

/**
 * Cordova Service
 */
@Injectable()
export class CordovaUIService {
    /**
     * On Resume Stream.
     */
    private resume: BehaviorSubject<boolean>;

    /**
     * Constructor.
     * @param zone NgZone
     * @param toastr toastr
     * @param logService LogService
     */
    constructor(private zone: NgZone,
                private toastr: ToastrService,
                private logService: LogService) {
        this.resume = new BehaviorSubject<boolean>(null);
        fromEvent(document, 'resume')
            .subscribe(() => {
                this.zone.run(() => {
                    this.onResume();
                });
            });
    }

    /**
     * Getter Cordova.
     */
    public static get cordova(): any {
        return _window().cordova;
    }

    /**
     * If the plaftorm is on Cordova
     */
    public static get onCordova(): boolean {
        return !!_window().cordova;
    }

    /**
     * On resume
     */
    public onResume(): void {
        this.logService.logLog('********* On Resume', 'CordovaUIService', 'onResume', 2);
        this.resume.next(true);
    }

    /**
     * Get the observable of the resume stream.
     * @return {Observable<boolean>}
     */
    public getOnResumeStream(): Observable<boolean> {
        return this.resume.asObservable();
    }


    /**
     * Dialog Confirmation
     * @param message message
     * @param title title
     * @param buttonLabels buttons Labels
     */
    public dialogConfirm(
        message: string,
        title?: string,
        buttonLabels?: string[]
    ): Promise<number> {
        // TODO implémenter Confirm Dialog Mieux pour la version WEB
        return new Promise(
            (resolve) => {
                if (CordovaUIService.onCordova && navigator != null && navigator.notification != null) {
                    navigator.notification.confirm(message, (num) => {
                        resolve(num);
                    }, title, buttonLabels);
                } else {
                    // @ts-ignore
                    if (window.electron != null) {
                        // @ts-ignore
                        window.electron.dialogConfirm(message, title, resolve);
                    } else {
                        if (confirm(message)) {
                            resolve(1);
                        } else {
                            resolve(2);
                        }
                    }
                }
            });
    }


    /**
     * Dialog Confirmation
     * @param message message
     * @param title title
     */
    public dialogAlert(
        message: string,
        title?: string
    ): Promise<void> {
        // TODO implémenter Confirm Dialog Mieux pour la version WEB
        return new Promise(
            (resolve) => {
                if (CordovaUIService.onCordova && navigator != null && navigator.notification != null) {
                    navigator.notification.alert(message, () => {
                        resolve();
                    }, title);
                } else {
                    // @ts-ignore
                    if (window.electron != null) {
                        // @ts-ignore
                        window.electron.dialogAlert(message, title, resolve);
                    } else {
                        alert(message);
                        resolve();
                    }
                }
            });
    }


    /**
     * To show a toast
     * @param messageContent the content
     * @param title the title
     */
    public toastSuccess(
        messageContent: string,
        title: string
    ): void {
        if (CordovaUIService.onCordova && _window().plugins != null && _window().plugins.toast != null) {
            _window().plugins.toast.showWithOptions({
                message : messageContent,
                duration: 'long', // 2000 ms
                position: 'bottom',
                styling : {
                    opacity          : 0.75, // 0.0 (transparent) to 1.0 (opaque). Default 0.8
                    backgroundColor  : '#28a745', // make sure you use #RRGGBB. Default #333333
                    textColor        : '#000000', // Ditto. Default #FFFFFF
                    textSize         : 13, // Default is approx. 13.
                    cornerRadius     : 16, // minimum is 0 (square). iOS default 20, Android default 100
                    horizontalPadding: 20, // iOS default 16, Android default 50
                    verticalPadding  : 16 // iOS default 12, Android default 30
                }
            });
        } else {
            this.toastr.success(messageContent, title, {});
        }
    }

    /**
     * To show a error toast
     * @param messageContent the content
     * @param title the title
     */
    public toastError(
        messageContent: string,
        title: string
    ): void {
        if (CordovaUIService.onCordova && _window().plugins != null && _window().plugins.toast != null) {
            _window().plugins.toast.showWithOptions({
                message : messageContent,
                duration: 'long', // 2000 ms
                position: 'bottom',
                styling : {
                    opacity          : 0.75, // 0.0 (transparent) to 1.0 (opaque). Default 0.8
                    backgroundColor  : '#af0f1f', // make sure you use #RRGGBB. Default #333333
                    textColor        : '#ffffff', // Ditto. Default #FFFFFF
                    textSize         : 13, // Default is approx. 13.
                    cornerRadius     : 16, // minimum is 0 (square). iOS default 20, Android default 100
                    horizontalPadding: 20, // iOS default 16, Android default 50
                    verticalPadding  : 16 // iOS default 12, Android default 30
                }
            });
        } else {
            this.toastr.error(messageContent, title, {});
        }
    }


}
